import { Primitive } from '../Primitive';
export class Numeric extends Primitive {
    value;
    constructor(type, value) {
        super(type);
        this.value = value;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTnVtZXJpYy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvbnVtZXJpYy9OdW1lcmljLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxjQUFjLENBQUE7QUFleEMsTUFBTSxPQUFPLE9BR1gsU0FBUSxTQUFTO0lBQ1IsS0FBSyxDQUFHO0lBRWpCLFlBQVksSUFBTyxFQUFFLEtBQVE7UUFDM0IsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFBO1FBQ1gsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUE7SUFDcEIsQ0FBQztDQUNGIn0=